export default __webpack_public_path__ + "static/media/frame-7.00992057.png";